
const baseURL = window.location.origin;

export default baseURL;
